import Desktop from 'components/Header/desktop';
import Mobile from 'components/Header/mobile';
import Tablet from 'components/Header/tablet';
import { useAuth } from 'contexts/auth';
import { useDialog } from 'contexts/dialog';
import { useViewport } from 'contexts/viewport';
import { isEmpty } from 'lodash';
import { useLocation } from 'react-router-dom';

const getNavOptions = (path, role) => {
    if (!role) {
        return [
            {
                key: 'courses',
                text: 'Courses',
                link: '/',
                icon: 'home',
            },
            {
                key: 'rubrics',
                text: 'Rubrics',
                link: '/rubrics',
                icon: 'dashboard',
            },
        ];
    }

    return path === '/'
        ? [
              {
                  key: 'courses',
                  text: 'Courses',
                  link: '/',
                  icon: 'home',
              },
              {
                  key: 'rubrics',
                  text: 'Rubrics',
                  link: '/rubrics',
                  icon: 'dashboard',
              },
          ]
        : {
              student: [
                  {
                      key: 'assignments',
                      text: 'Assignments',
                      link: '/assignments',
                      icon: 'task',
                  },
              ],
              instructor: [
                  {
                      key: 'assignments',
                      text: 'Assignments',
                      link: '/assignments',
                      icon: 'task',
                  },
                  {
                      key: 'rubrics',
                      text: 'Rubrics',
                      link: '/rubrics',
                      icon: 'dashboard',
                  },
                  {
                      key: 'people',
                      text: 'People',
                      link: '/people',
                      icon: 'teams',
                  },
              ],
          }[role];
};

const getDropdownOptions = (isLoggedIn, role) => {
    const universalDropdownOptions = [
        { key: 'user' },
        { key: 'divider' },
        { key: 'profile', value: 'Account Settings' },
    ];

    return process.env.REACT_APP_AUTH === 'LTI'
        ? [
              ...universalDropdownOptions,
              ...(isLoggedIn
                  ? [
                        ...(role === 'instructor' ? [{ key: 'course-settings', value: 'Course Settings' }] : []),
                        { key: 'courses', value: 'Course Dashboard' },
                    ]
                  : []),
          ]
        : [
              ...universalDropdownOptions,
              ...(isLoggedIn
                  ? [
                        ...(role === 'instructor' ? [{ key: 'course-settings', value: 'Course Settings' }] : []),
                        { key: 'switch-course', value: 'Switch Course' },
                    ]
                  : []),
              { key: 'divider' },
              { key: 'logout', value: 'Log Out' },
          ];
};

const Header = () => {
    const { auth, logout, changeAccount } = useAuth();
    const { setDialog, closeDialog } = useDialog();
    const location = useLocation();
    const { device } = useViewport();

    const navOptions = getNavOptions(location.pathname, auth.role);
    const dropdownOptions = getDropdownOptions(auth.owner_account_id, auth.role);

    const handleLogout = () => {
        setDialog({
            open: true,
            message: 'Logging Out?',
            description: 'Are you sure you would like to log out of TimelyGrader?',
            note: '',
            variant: 'destructive',
            actionButtonText: 'Log Out',
            cancelButtonText: 'Cancel',
            onAction: () => {
                logout({ isExpired: false });
                closeDialog();
            },
            onCancel: () => closeDialog(),
            onClose: () => closeDialog(),
        });
    };

    const props = {
        navOptions,
        dropdownOptions,
        logout: handleLogout,
        ...(process.env.REACT_APP_AUTH === 'PASSWORD' && { changeAccount }),
    };

    const renderResponsiveLayout = (device) => {
        return {
            mobile: <Mobile {...props} />,
            tablet: <Tablet {...props} />,
            desktop: <Desktop {...props} />,
        }[device];
    };

    return isEmpty(auth) ? null : renderResponsiveLayout(device);
};

export default Header;
